import { Record } from 'immutable';
import {
  CONNECTED_ENUM,
  FETCH_VPN_STATUS,
  VPN_START,
  VPN_STOP,
} from './constants';

const InitialState = Record({
  connectionState: 'unknown',
  disableButton: false,
  statusText: '',
});
const initialState = new InitialState();

export default function vpnReducer(state = initialState, action = undefined) {
  switch (action.type) {
    case `${VPN_STOP}_START`:
    case `${VPN_START}_START`:
      return state.set('disableButton', true);
    case `${VPN_STOP}_ERROR`:
    case `${VPN_START}_ERROR`:
    case `${FETCH_VPN_STATUS}_ERROR`:
      return state
        .set('connectionState', CONNECTED_ENUM.unknown)
        .set('disableButton', false);
    case `${FETCH_VPN_STATUS}_START`:
      return state
        .set('connectionState', CONNECTED_ENUM.unknown)
        .set('disableButton', true);
    case `${VPN_START}_SUCCESS`:
    case `${VPN_STOP}_SUCCESS`:
    case `${FETCH_VPN_STATUS}_SUCCESS`: {
      const {
        payload: { status, statusText },
      } = action;
      return state
        .set('connectionState', CONNECTED_ENUM[status])
        .set('statusText', statusText)
        .set('disableButton', false);
    }
    default:
      return state;
  }
}
